var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete2X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5220\u9664") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u533A\\u5757",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-287.000000, -195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-41",
    transform: "translate(47.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(112.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(128.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.01,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5909598,2.43271731 L14.5909598,3.58400675 L13.3850402,3.584 L13.3858817,14.298358 C13.3858817,15.1828671 12.7060096,15.9097548 11.8366931,15.9922104 L11.671596,16 L4.61662946,16 C3.72554819,16 2.99325955,15.3251423 2.91019127,14.4622375 L2.90234375,14.298358 L2.90204018,3.584 L1.40904018,3.58400675 L1.40904018,2.43271731 L14.5909598,2.43271731 Z M12.2420402,3.584 L4.04504018,3.584 L4.04520089,14.298358 C4.04520089,14.5768146 4.24734393,14.8084063 4.51391446,14.8564334 L4.61662946,14.865572 L11.671596,14.865572 C11.9521216,14.865572 12.1854341,14.6649199 12.2338181,14.4003154 L12.2430246,14.298358 L12.2420402,3.584 Z M6.55691964,4.76171738 L6.55691964,13.69714 L5.4140625,13.69714 L5.4140625,4.76171738 L6.55691964,4.76171738 Z M8.72670201,4.76171738 L8.72670201,13.69714 L7.58384487,13.69714 L7.58384487,4.76171738 L8.72670201,4.76171738 Z M10.8964844,4.76171738 L10.8964844,13.69714 L9.75362723,13.69714 L9.75362723,4.76171738 L10.8964844,4.76171738 Z M10.3250558,0 L10.3250558,1.15128944 L5.98549107,1.15128944 L5.98549107,0 L10.3250558,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2X);
export default __webpack_public_path__ + "static/media/delete@2x.3daf2a34.svg";
export { ForwardRef as ReactComponent };